import { Component } from "react";
import { Plane, RefreshCw, Home } from "lucide-react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#f8fafc] flex items-center justify-center px-4" data-testid="error-boundary">
          <div className="text-center max-w-sm">
            <div className="w-16 h-16 bg-red-50 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <Plane className="w-8 h-8 text-red-400 -rotate-45" />
            </div>
            <h1 className="font-['Outfit'] text-2xl font-bold text-[#1e293b] mb-2">Something Went Wrong</h1>
            <p className="text-sm text-[#64748b] mb-8">An unexpected error occurred. Please try again.</p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => window.location.replace("/")}
                className="flex items-center gap-2 bg-[#1e3a5f] text-white px-5 py-2.5 rounded-xl text-sm font-medium hover:bg-[#152e4d] transition-colors"
                data-testid="error-go-home"
              >
                <Home className="w-4 h-4" /> Go Home
              </button>
              <button
                onClick={() => window.location.reload()}
                className="flex items-center gap-2 border border-[#e2e8f0] text-[#475569] px-5 py-2.5 rounded-xl text-sm font-medium hover:bg-white transition-colors"
                data-testid="error-reload"
              >
                <RefreshCw className="w-4 h-4" /> Reload
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
